<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col>
        <router-link :to="{ name: 'qa_setting', params: $route.params }" class="btn btn-ptc1" tag="button">返回</router-link>
      </b-col>
      <b-col class="text-center title">常見問題 / 常見問題設定 / 編輯</b-col>
      <b-col>
        <div class="text-right">
          <button type="button" class="btn btn-save" @click="checkModelByOpen">儲存</button>
          <!-- <button type="button" class="btn btn-clear">清除</button> -->
          <!-- <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn> -->
        </div>
      </b-col>
    </b-row>
    <div id="func-content">
      <div class="contact-page">
        <b-modal ref='checkModel' hide-footer title='修改常見問題'>
          <div class="d-block text-center" style="margin-bottom: 12px;">
            確認修改?
          </div>
          <div class="d-block text-right">
            <b-btn variant="primary" @click="save">確定</b-btn>
            <b-btn variant="secondary" @click="checkModelByCancel">取消</b-btn>
          </div>
        </b-modal>
        <!-- <div class="row"> -->
        <div class="col-lg-12">
          <b-card>
            <div class="row">
              <b-container fluid>
                <form>
                  <div class="row mb-3">
                    <label class="control-label col-md-3">分類：</label>
                    <div class="col-md-7">
                      <select class="form-control" v-model="categroyID">
                        <option disabled value="">請選擇分類</option>
                        <option v-for="x in categoryList" v-bind:value="x.categoryId" :key="x.categoryId">{{x.categoryName}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="control-label col-md-3">問題：</label>
                    <div class="col-md-7">
                      <textarea v-model="question" rows="3" class="form-control resize_vertical" placeholder="請輸入問題" required></textarea>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="control-label col-md-3">答案：</label>
                    <div class="col-md-7">
                      <textarea v-model="answer" rows="7" class="form-control resize_vertical" placeholder="請輸入答案" required></textarea>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="control-label col-md-3">異動人員：</label>
                    <div class="col-md-7">
                      <input type="text" disabled class="form-control" v-model="updatedName">
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label class="control-label col-md-3">異動時間：</label>
                    <div class="col-md-7">
                      <input type="text" disabled class="form-control" v-model="updatedAt">
                    </div>
                  </div>
                </form>
              </b-container>
            </div>
          </b-card>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>
<script>
// for API_URL
import axios from 'axios'
import {
  API_URL
} from '../../store/root.js'

import miniToastr from 'mini-toastr'
miniToastr.init()
export default {
  name: 'blank',
  data () {
    return {
      categoryList: [],
      qaId: 0,
      answer: '',
      question: '',
      categroyID: '',
      updatedName: '',
      updatedAt: ''
    }
  },
  components: {},
  mounted: function () { },
  created () {
    this.load()
  },
  methods: {
    getCategory: function () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/qa/categoryquery')
        .then((response) => {
          if (response.data.result === '0000') {
            this.categoryList = response.data.data
          } else if (response.data.result === '0006') {
            this.$parent.logOut(false, true)
          } else {
            miniToastr.error(response.data.message, '錯誤訊息')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    load () {
      if (this.$route.name === 'qa_edit') {
        this.qaId = this.$route.params.data.QAID
        this.answer = this.$route.params.data.answer
        this.question = this.$route.params.data.question
        this.categroyID = this.$route.params.data.typeId
        this.updatedName = this.$route.params.data.updatedName
        this.updatedAt = this.$route.params.data.updatedAt

        if (this.$route.params.categoryList) { this.categoryList = this.$route.params.categoryList } else { this.getCategory() }
      } else {
        miniToastr.error('編輯資料錯誤', '錯誤訊息')
      }
    },
    checkModelByOpen () {
      if (!this.verification()) return
      this.$refs.checkModel.show()
    },
    checkModelByCancel () {
      this.$refs.checkModel.hide()
    },
    save () {
      this.checkModelByCancel()
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/qa/update', {
        qaID: this.qaId,
        categroyID: this.categroyID,
        categoryName: this.categoryList.filter(x => x.categoryId === this.categroyID)[0].categoryName,
        question: this.question,
        answer: this.answer
      })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('新增成功')
            this.$router.push({
              name: 'qa_setting'
            })
          } else if (response.data.result === '0006') {
            this.$parent.logOut(false, true)
          } else {
            miniToastr.error(response.data.message, '錯誤訊息')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    verification () {
      var bRef = true
      var errorMsg = []
      if (this.categroyID === '') { errorMsg.push('分類不可不選') }
      if (this.question === '') { errorMsg.push('問題不可為空') }
      if (this.answer === '') { errorMsg.push('答案不可為空') }
      if (errorMsg.length > 0) {
        miniToastr.error(errorMsg.join('、'), '錯誤訊息')
        this.$parent.verificationErrMsg()
        bRef = false
      }
      return bRef
    }
  },
  computed: {}
}

</script>



// WEBPACK FOOTER //
// src/pages/qa/Edit.vue